import { createFileRoute } from "@tanstack/react-router"

import { ReservationsRouteComponent } from "@/routes/_authenticated/account/reservations"
import {
  currentReservationsQueryOptions,
  pastReservationsQueryOptions,
} from "@/utilities/hooks/queries/reserve"
import { themeQueryOptions } from "@/utilities/hooks/queries/shared"
import { Crumb } from "@/utilities/types/local"

export const Route = createFileRoute(
  "/qr/$qrLookupID/_authenticated/account/reservations"
)({
  staticData: {
    pageName: "Reservations",
  },
  loader: async ({ context, params }) => {
    const theme = await context.queryClient.ensureQueryData(
      themeQueryOptions({ qrLookupID: params.qrLookupID })
    )
    const locationID = theme?.locationInformation.locationID || null
    await Promise.all([
      context.queryClient.ensureQueryData(
        currentReservationsQueryOptions(locationID)
      ),
      context.queryClient.ensureQueryData(
        pastReservationsQueryOptions(locationID)
      ),
    ])
    return {
      locationID,
      crumb: { translationKey: "common:reservations.header" } as Crumb,
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locationID } = Route.useLoaderData()
  return <ReservationsRouteComponent locationID={locationID} />
}
